export enum Pages {
  VerifyEligibility = '/',
  Review = '/review',
  Confirmation = '/confirmation',
  UpdateEmails = '/email',
  Error = '/error',
  AutoPay = '/autopay',
}
